import React from 'react';
import { Stack } from '@mui/material';
import { Images } from '../../assets/common';

export default function Bidding({ nftDetails, onClick }) {
  return (
    <Stack
      onClick={() => onClick()}
      sx={{
        cursor: 'pointer',
        margin: '5px 0',
        alignItems: 'center',
      }}
    >
      <img
        className="avatar-sm"
        src={
          nftDetails?.details?.thumbnailImg?.filePath || Images.music_default
        }
        alt="NFT"
        style={{
          borderRadius: '8px',
          width: '60px',
          height: '60px',
        }}
      />
    </Stack>
  );
}
